import React from 'react'
import classNames from 'classnames'
import style from '../scss/components/Column.module.scss'

type ColumnPropTypes = {
    children: any
    bottomOffset: boolean
}

const Column = (props: ColumnPropTypes) => {
    return (
        <div className={classNames(style.Column, {
            [style.BottomOffset]: props.bottomOffset,
        })}>
            {props.children}
        </div>
    )
}

Column.defaultProps = {
    bottomOffset: false,
}

export default Column
